import { Box } from '@mui/material'
import GradingListCoefficient from './Coefficient'
import GradingListScales from './Scales'
import { useDispatch, useSelector } from 'react-redux'
import { getCourseLevel, getGradingMethods } from 'store/lookup'
import { useEffect, useState } from 'react'
import { search } from 'store/settings/grading-scale'

export default function GradingListIndex() {
  const dispatch = useDispatch()
  const courseLevel = useSelector(state => state?.lookup?.courseLevel)
  const gradingMethods = useSelector(state => state?.lookup?.gradingMethods)

  const { list: scales } = useSelector(state => state?.settings?.gradingScale)
  const { academicYear } = useSelector(state => state.session)
  const [expanded, setExpanded] = useState('panel1')

  useEffect(() => {
    dispatch(getCourseLevel())
    dispatch(getGradingMethods())
    getScaleList()
  }, [academicYear])

  const getScaleList = async () => {
    await dispatch(search())
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  // if (!courseLevel || !scales) return null

  return (
    <Box >
      <Box sx={{ pt: 2, display: 'flex', justifyContent: 'flex-end' }}>
      </Box>
      <GradingListCoefficient data={courseLevel} gradingMethods={gradingMethods} expanded={expanded} setExpanded={setExpanded} handleChange={handleChange} />
      <GradingListScales list={scales} expanded={expanded} setExpanded={setExpanded} handleChange={handleChange} />
    </Box>
  )
}
